// NetworkStatus.jsx - Component to monitor network status
import React, { useState, useEffect } from 'react';
import ErrorHandler from './ErrorHandler';
import './NetworkStatus.css';

const NetworkStatus = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showOfflineMessage, setShowOfflineMessage] = useState(false);
  const [reconnected, setReconnected] = useState(false);

  useEffect(() => {
    // Function to handle when the user comes back online
    const handleOnline = () => {
      setIsOffline(false);
      setReconnected(true);
      
      // After 5 seconds, hide the reconnection message
      setTimeout(() => {
        setReconnected(false);
      }, 5000);
    };

    // Function to handle when the user goes offline
    const handleOffline = () => {
      setIsOffline(true);
      setShowOfflineMessage(true);
    };

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Handle dismissal of the offline message
  const dismissOfflineMessage = () => {
    setShowOfflineMessage(false);
  };

  // Handle retry action
  const handleRetry = () => {
    // Attempt to refresh data or reconnect
    window.location.reload();
  };

  if (reconnected) {
    return (
      <div className="network-status reconnected">
        <div className="status-message">
          <span className="status-icon">✓</span>
          <span>You're back online!</span>
          <button 
            className="dismiss-status-btn"
            onClick={() => setReconnected(false)}
            aria-label="Dismiss message"
          >
            ✕
          </button>
        </div>
      </div>
    );
  }

  if (isOffline && showOfflineMessage) {
    return (
      <ErrorHandler 
        isOffline={true}
        resetError={dismissOfflineMessage}
        retryAction={handleRetry}
      />
    );
  }

  return null;
};

export default NetworkStatus;